import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=4b63c3b2&scoped=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=ts"
export * from "./PaymentInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b63c3b2",
  null
  
)

export default component.exports